import React, { Component } from "react";
import logo2 from "../assets/logo2.png";

class SeminarChula2 extends Component {
  state = { registered: {} };
  seminar = "chula"; // ✅ unique seminar name for this page

  componentDidMount() {
    this.fetchRegistered();
    // optional: auto-refresh every 10s so all screens stay synced
    this.interval = setInterval(this.fetchRegistered, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchRegistered = async () => {
    try {
      const res = await fetch(`/api/registered?seminar=${this.seminar}`);
      const data = await res.json();
      this.setState({ registered: data });
    } catch (err) {
      console.error(`Error fetching ${this.seminar} data:`, err);
    }
  };

  handleRegister = async (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      // Ask admin PIN for unregister
      const pin = window.prompt("Enter PIN to unregister:");
      const res = await fetch("/api/unregister", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ seminar: this.seminar, id, pin }),
      });

      if (res.ok) {
        const data = await res.json();
        this.setState({ registered: data });
        alert("Unregistered successfully.");
      } else {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      // Ask to register
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        const res = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ seminar: this.seminar, id }),
        });
        const data = await res.json();
        this.setState({ registered: data });
      }
    }
  };

  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue", // 🔵 blue default, 🔴 red when registered
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="RosterTuesday1">
        <h3>Chulalongkorn University Participants Day 2</h3>
        <br />
        <br />

        {this.renderParticipant(1, "นายนิวัฒน์ สีสังข์งาม")}
        <br />
        {this.renderParticipant(2, "นายวิชัย ชีวพิทักษ์ผล")}
        <br />
        {this.renderParticipant(3, "นายนฤพร เสาวนิตย์")}
        <br />
        {this.renderParticipant(4, "Mr.Phumiphat Phumariyapong")}
        <br />
        {this.renderParticipant(5, "Ms.Yotsawadee Potippayawong")}
        <br />
        {this.renderParticipant(6, "Mr.Kanapod Konsri")}
        <br />

        <div>ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...</div>
        <br />
        <br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarChula2;
